import React, { createContext, useContext, useEffect, useState } from "react";
import { MemberDetailsInfo, CompanyType, ReferenceTypes, LocalAuthority} from '../my-account/types';
import { useMemberStaleAwareData } from "./useMemberStaleAwareData";
import { UseReferenceTypeStaleAwareData } from "./useReferenceTypeStaleAwareData";
import { defaultReferenceTypes } from "./ReferenceTypes/defaultReferenceTypes";
import { defaultMemberContextRoot } from "./memberContext/defaultMemberContextRoot";


export type CompanyDetailsFormState = 'clean' | 'dirty' | 'submitted' | 'invalid';

export type MembershipInfoContextValue = {
    membershipNumber: string
    membershipInfo: MemberDetailsInfo;
    setMembershipInfo: (membershipInfo: MemberDetailsInfo) => void;
    companyTypes: CompanyType[];
    localAuthority: LocalAuthority[];
    referenceTypes: ReferenceTypes;
    formState: CompanyDetailsFormState,
    setFormState: (state: CompanyDetailsFormState) => void,
    isLoadingMembershipInfo: boolean
}

const MembershipInfoContext = createContext<MembershipInfoContextValue>({
    membershipNumber: null,
    membershipInfo: null,
    setMembershipInfo: (membershipInfo: MemberDetailsInfo) => { },
    companyTypes: [],
    localAuthority: [],
    referenceTypes: defaultReferenceTypes,
    formState: 'clean',
    setFormState: () => { },
    isLoadingMembershipInfo: true
});

export const MembershipInfoProvider = ({ children }: React.PropsWithChildren<{}>) => {
    const {data: referenceTypesData} = UseReferenceTypeStaleAwareData();
    const {data: memberData, isLoading: isLoadingMembershipInfo, reload, lastLoaded} = useMemberStaleAwareData();
    const membershipNumber = memberData.membershipNumber;
    const [formState, setFormState] = useState<CompanyDetailsFormState>('clean');
    const [membershipInfo, setMembershipInfo] = useState<MemberDetailsInfo>(memberData as MemberDetailsInfo);

    useEffect(()=> {
        if (!!memberData?.companyTypeId) {
                    const companyType = referenceTypesData.companyType.filter(ct => memberData.companyTypeId === ct.id)[0]
                    
                    setMembershipInfo(prev => {
                        return {...prev, 
                            companyType: companyType ? { id: companyType.id, text: companyType.text } : null,
                        } 
                    });
                }
    }, [referenceTypesData, memberData])

    useEffect(() => {
        function isWithinLast5Seconds(date) {
        const now = Date.now();
        const inputTime = new Date(date).getTime();

        return (now - inputTime) <= 5000;
        }

        if (!isWithinLast5Seconds(lastLoaded))
          reload();
    }, [membershipInfo])


    const companyTypes : CompanyType[] = referenceTypesData?.companyType ?? [];
    const localAuthority: LocalAuthority[] = referenceTypesData?.localAuthority ?? [];
    const referenceTypes: ReferenceTypes = referenceTypesData ?? defaultReferenceTypes;

    var contextValue: MembershipInfoContextValue = {
        membershipNumber, 
        membershipInfo, 
        referenceTypes,
        setMembershipInfo, 
        companyTypes, 
        localAuthority, 
        formState, 
        setFormState,
        isLoadingMembershipInfo
    };                        

    return <MembershipInfoContext.Provider value={contextValue}>{children}</MembershipInfoContext.Provider>                          
 
}

export const useMembershipInfoContext = () => useContext(MembershipInfoContext);

